import React from 'react';
import { cn } from '@/lib/utils';

/**
 * The small "ETF" chip that marks a fund wherever a ticker is shown next to
 * single-stock readings — Navbar search rows, the ticker popup's stats
 * cluster. One component so the chip reads the same everywhere; the popup
 * shows it IN PLACE of beta, which is a single-stock exposure number and is
 * hidden for funds.
 */
export function EtfBadge({ className, title = 'Exchange-traded fund' }: { className?: string; title?: string }): React.JSX.Element {
  return (
    <span
      title={title}
      aria-label="ETF"
      className={cn(
        'text-[9px] font-bold px-1 py-0.5 rounded bg-emerald-500/15 text-emerald-400 border border-emerald-500/20',
        className,
      )}
    >
      ETF
    </span>
  );
}

export default EtfBadge;
